<ng-template #adminContent>
  @if(isLoggedIn$ | async) {
    <htx-button
      variant="secondary"
      size="medium"
      icon="person"
      [iconOnly]="true"
      [openOnHover]="true"
      [dropdownAlign]="'right'"
      [dropdownHeader]="('menu.profileGreeting' | transloco) + ' ' + (displayName$ | async)"
      [dropdownItems]="(profileMenuRoutes$ | async) ?? []"
      (dropdownItemSelected)="onAdminMenuItemSelected($event)"
    >
    </htx-button>
  }
</ng-template>
<htx-header
  [navigationItems]="(navigationRoutes$ | async) ?? []"
  [extraSpaceTemplate]="adminContent"
  [isLoggedIn]="(isLoggedIn$ | async) ?? false"
  [loginButtonLabel]="'menu.login' | transloco"
  [isLogoutButtonVisible]="false"
  [mobileBreakpoint]="1350"
  [availableLangs]="availableLangs"
  [activeLang]="activeLang()"
  (loginClicked)="login()"
  (logoClicked)="logoClick()"
  (navigationItemClicked)="onNavigationItemClicked($event)"
  (langChanged)="setLang($event)"
></htx-header>
<router-outlet></router-outlet>

@if (useMocks) {
  <app-mock-data-switcher></app-mock-data-switcher>
}

<htx-scroll-to-top></htx-scroll-to-top>
